import {
  DEFAULT_API_RESPONSE,
  DEFAULT_PAGER,
  FilterType,
  TDataTablePager,
} from '@monetize/types/common';
import { useMemo, useState } from 'react';
import { useGetAccountRefundsByAccount } from '../../api/accountsService';
import {
  buildFilterParamsRequestObject,
  transformTableFilterValue,
} from '../../utils';

export const useAccountRefunds = ({ accountId }: { accountId: string }) => {
  const [filters, setFilters] = useState<FilterType[]>([]);
  const [pager, setPager] = useState<TDataTablePager>(DEFAULT_PAGER);

  const filterParams = useMemo(
    () =>
      buildFilterParamsRequestObject(
        transformTableFilterValue(filters, ['settledDate']),
      ),
    [filters],
  );

  const {
    isLoading,
    isFetched,
    isRefetching,
    data: accountRefunds,
    refetch,
    isError,
    error,
  } = useGetAccountRefundsByAccount(
    {
      accountId,
      config: pager,
      filters: filterParams,
    },
    {
      meta: { showErrorToast: true },
      // Keep the current page while a sort/filter/page change loads, as the
      // payments and documents lists do; otherwise the list empties and the
      // page header (hidden for an empty list) blinks out.
      placeholderData: (previousData) => previousData,
    },
  );

  const onResetFilter = () => {
    setFilters([]);
    setPager(DEFAULT_PAGER);
  };

  return {
    pager,
    setPager,
    filters,
    setFilters,
    onResetFilter,
    refetch,
    isError,
    error,
    totalRecords: accountRefunds?.totalElements || 0,
    loading: isLoading || (isRefetching && !isFetched),
    listData: accountRefunds || DEFAULT_API_RESPONSE,
  };
};
